module.exports = __webpack_public_path__ + "src/img/down.83316360.svg";